import React, { useCallback, useRef, useMemo, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Form } from '@unform/web';


// COMPONENTES GERAIS
import Modal, { ModalHeader } from "~/components/Modal";
import InputGroup, { InputGroupAddon, InputGroupButton } from "~/components/Bootstrap/InputGroup";
import InputSmall from "~/components/Inputs/Normal/Small";
import { ColSm12, ColSm2, ColSm3, ColSm4, ColSm6, ColSm8 } from '~/components/Bootstrap/Col';
import Row from '~/components/Bootstrap/Row';

// STYLED COMPONENTS
import { Main, Content, Footer } from "../styles";

// TABLE
import Table from '~/components/TableR';

// BUTONS
import ButtonSecondary from '~/components/Buttons/Normal/Secondary';

// UTILS
import NotificacaoUtil from '~/utils/notificacao';
import Utils from "~/utils";

// SERVICES
import APIRequests from "~/services/requests_api";


const TabTransacoesOnline = ({ UUID }) => {

    /**
    * Dados de paginação para crédito da carteira
    */
    const [NavPageCountCarteira, setNavPageCountCarteira] = useState(0);
    const [NavCurrentPageCarteira, setNavCurrentPageCarteira] = useState(1);
    const [NavLimitPerPageCarteira, setNavLimitPerPageCarteira] = useState(10);
    const [NavTotalRowsCarteira, setNavTotalRowsCarteira] = useState(0);

    const [RegistrosTransacoesOnline, setRegistrosTransacoesOnline] = useState([]);

    const [SaldoCaixa, setSaldoCaixa] = useState(0);

    /**
     * Carrega os  registros de crédito carteira
     */
    const onRequestListaRegistrosTransacoesOnline = useCallback(async () => {

        const dados_transacoes_online = await APIRequests.transacoes_online.listar(UUID, NavCurrentPageCarteira, NavLimitPerPageCarteira);

        if (dados_transacoes_online.results) {
            setNavPageCountCarteira(dados_transacoes_online.metadata.page.total);
            setNavTotalRowsCarteira(dados_transacoes_online.metadata.total);

            /**
             * Carrega os dados adicionais do usuário
             */
            setRegistrosTransacoesOnline(dados_transacoes_online.results);
        }
    }, [
        NavLimitPerPageCarteira,
        NavCurrentPageCarteira,
        UUID
    ]);

    /**
     * Buscando saldo
     */
    const onRequestSaldo = useCallback(async () => {

        const saldo = await APIRequests.transacoes_online.saldo(UUID);

        if (saldo) {
            /**
             * Carrega os dados adicionais do usuário
             */
            setSaldoCaixa(saldo?.saldo ?? 0);
        }
    }, [
        NavLimitPerPageCarteira,
        NavCurrentPageCarteira,
        UUID
    ]);


    /**
     * Quando navegar na tabela de carteira
     */
    const onTableNavChangeCarteira = useCallback((data) => {
        setNavLimitPerPageCarteira(data.limit);
        setNavCurrentPageCarteira(data.page + 1);
    }, [])


    /**
     * Dispara requisições para backend.
     */
    useEffect(() => {
        const timeout = setTimeout(() => {
            onRequestListaRegistrosTransacoesOnline();
            onRequestSaldo();
        }, 100);
        return () => clearTimeout(timeout);
    }, [
        UUID,
        NavLimitPerPageCarteira,
        NavCurrentPageCarteira,
    ]);

    /**
     * Colunas da tabela
     */
    const TableColumns = useMemo(() => [
        {
            accessor: 'id',
            width: 10,
            disableSortBy: true,
            Header: () => (
                <center>
                    #
                </center>
            ),

            Cell: ({ value }) => {
                return (
                    <center>
                        {value}
                    </center>
                )
            }

        },
        {
            Header: 'Adquirente',
            accessor: 'adquirente',
            disableSortBy: true,
            width: 20,

            Header: () => (
                <center>
                    Adquirente
                </center>
            ),

            Cell: ({ value }) => {
                return (
                    <center>
                        {value}
                    </center>
                )
            }
        },
        {
            Header: 'Cod. autorização',
            accessor: 'cod_autorizacao',
            disableSortBy: true,
            width: 20
        },

        {
            Header: 'NSU',
            accessor: 'nsu',
            disableSortBy: true,
            width: 20
        },

        {
            Header: 'Status',
            accessor: 'status',
            disableSortBy: true,
            width: 20
        },

        {
            Header: 'Transação id',
            accessor: 'transaction_id',
            disableSortBy: true,
            width: 65
        },
        {
            Header: 'Valor',
            accessor: 'valor',
            width: 20,
            disableSortBy: true,
            Header: () => (
                <center>
                    Valor
                </center>
            ),
            Cell: ({ value }) => {
                return (
                    <center>
                        {Utils.FormataValor(value)}
                    </center>
                )
            }
        },

        {
            Header: 'Data',
            accessor: 'criado_em',
            width: 35,
            disableSortBy: true,
            Header: () => (
                <center>
                    Data
                </center>
            ),
            Cell: ({ value }) => {
                return (
                    <center>
                        {Utils.FormataDataHora(value)}
                    </center>
                )
            }
        },
    ], []);

    const TableInitialSortBy = [{
        id: 'criado_em',
        desc: true
    }]


    return (
        <>
            <Row>
                <ColSm4>
                    <InputGroup small>
                        <InputGroupAddon>
                            TOTAL TRANSAÇÕES
                        </InputGroupAddon>
                        <InputSmall
                            style={{ color: SaldoCaixa > 0 ? '#41924c' : '#b14545' }}
                            value={Utils.FormataTotal(SaldoCaixa)}
                            disabled
                        />
                    </InputGroup>
                </ColSm4>
            </Row>

            <Table
                nostriped

                initialSortBy={TableInitialSortBy}

                pageIndex={NavCurrentPageCarteira - 1}
                pageCount={NavPageCountCarteira}
                totalRows={NavTotalRowsCarteira}

                data={RegistrosTransacoesOnline}
                columns={TableColumns}

                onChangeNav={onTableNavChangeCarteira}
            />
        </>
    );

}


export default TabTransacoesOnline;